exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "span[data-v-0f7974f0]{font-size:15px!important}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/configuration-general/configuration-payment-methods.vue"],"names":[],"mappings":"AACA,sBACC,wBAA2B,CAC3B","file":"configuration-payment-methods.vue","sourcesContent":["\nspan[data-v-0f7974f0] {\n\tfont-size: 15px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f7974f0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/configuration-general/configuration-payment-methods.vue
// module id = 1050
// module chunks = 24